
import React, { Component } from 'react';
import withFeatureFlags from '../FeatureFlags/withFeatureFlags';
import './LiveChat.scss';
import OOHImg from '../../assets/images/chat_ooh.svg';
import CloseImg from '../../assets/images/closeChatButton.svg';

/** @import {WithFeatureFlagsProps} from '../FeatureFlags/FeatureFlagsTypes' */
/** @import {OohButtonProps, OohButtonState, OohTextProps, OohTextState, OohTextWithOpsEmailProps, OohTextWithOpsEmailState} from './ChatDownTimeTypes' */

/** @extends {Component<OohTextProps, OohTextState>} */
class OohText extends Component {
    state = {
        showing: false
    };

    onClickSubmitButton = () => 
        this.props.onCh();

    render() {
        return (
            <div className='ChatInfo'>
                <div className='ChatInfo__Header'>
                    <img src={OOHImg} className='' />
                    <div className='ChatInfo__Title'>Live Chat</div>
                    <div className='ChatInfo__Close' onClick={() => this.onClickSubmitButton()}><img src={CloseImg} className='' /></div>
                </div>
                <div className='ChatInfo__ChatContent'>
                    <p>Our live chat service is down.<br /><br />We apologise for the inconvenience and are working to resolve the issue. <br /><br />We'll post any updates here.</p>
                </div>
            </div>
        );
    }
}

/** @extends {Component<OohTextWithOpsEmailProps, OohTextWithOpsEmailState>} */
class OohTextWithOpsEmail extends Component {
    state = {
        showing: false
    };

    onClickSubmitButton = () =>
        this.props.onCh();

    render() {
        return (
            <div className='ChatInfo'>
                <div className='ChatInfo__Header'>
                    <img src={OOHImg} className='' />
                    <div className='ChatInfo__Title'>Live Chat</div>
                    <div className='ChatInfo__Close' onClick={() => this.onClickSubmitButton()}><img src={CloseImg} className='' /></div>
                </div>
                <div className='ChatInfo__ChatContent'>
                    <p>
                        Our live chat service is down.
                        <br /><br />
                        We apologise for the inconvenience and are working to resolve the issue.
                        <br /><br />
                        For anything urgent, please email us using InvestecSavingsServicing@investec.co.uk 
                        <br /><br />
                        We'll post any updates here
                    </p>
                </div>
            </div>
        );
    }
}

/** @extends {Component<OohButtonProps, OohButtonState>} */
class OohButton extends Component {
    state = {
        chatVisible: false,
        chatTextVisible: true
    };

    onClickButton = () =>
        this.setState(prevState => ({
            chatVisible: !prevState.chatVisible,
            chatTextVisible: !prevState.chatTextVisible
        }));

    changedChat = () => 
        this.onClickButton();

    renderText = () => {
        if (this.props.withOpsEmail)
            return (<OohTextWithOpsEmail onCh={this.changedChat} />)
        
        return (<OohText onCh={this.changedChat} />);
    }

    render() {
        return (
            <section className='LiveChat'>
                <div className='LiveChat__wrapper' onClick={() => this.onClickButton()}
                    style={this.state.chatVisible ? { display: "none" } : { display: "flex" }}  >
                    <div className='chat__chaticon-container'>
                        <img src={OOHImg} className='' />
                    </div>
                    <div className='chat__chatbutton-title'>
                        <div className="chat-t1" aria-label="Live chat">Live chat</div>
                        {/* <div className="chat-t2" aria-label="Need help?">We're offline</div> */}
                    </div>
                </div>
                {this.state.chatVisible ? this.renderText() : null}
            </section>

        );
    }
}

/** @extends {Component<WithFeatureFlagsProps>} */
class OohChatBox extends Component {
    render() {
        if (this.props.featureEnabled("ChatDownTime")) {
            return <OohButton withOpsEmail={this.props.featureEnabled('EnableOpsEmailAddressInOfflineWidget')} />;
        }
        return null;
    }
}

export default withFeatureFlags(OohChatBox);


